module.exports = __webpack_public_path__ + "static/media/vinyl.b9357e69.png";